import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import './theme.css';

Vue.use(Vuetify, {
  theme: {
    primary: '#0067af',
    secondary: '#1976d2',
    info: '#8aafe8',
    accent: '#192b46',
    success: '#00a65a',
    atention: '#ff5722',
    error: '#d33724',
  },
});
